/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */

enum PAnalysisMethod {
    BrayI = "BrayI",
    BrayII = "BrayII",
    Olsen = "Olsen",
    MehlichIII = "MehlichIII"
}

export default PAnalysisMethod;
